import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import {
    DEPARTMENTS_PARAMS,
    DEPARTMENTS_SLUGS,
} from '@features/settings/departments/departments.routes';
import { Department } from '@features/settings/departments/models/departments.types';
import { DepartmentsHttpService } from '@features/settings/departments/services/departments.http.service';
import { APP_SLUGS, MAIN_SLUGS, SETTINGS_SLUGS } from '@routes/routes.types';
import { catchError, Observable, of } from 'rxjs';

export const departmentByIdResolver: ResolveFn<Observable<Department | undefined>> = (
    route,
    _state
) => {
    const departmentHttpS = inject(DepartmentsHttpService);
    const router = inject(Router);
    const id = route.paramMap.get(DEPARTMENTS_PARAMS.id);
    if (!id) throw new Error('ID not found in route params');

    return departmentHttpS.getById$(id).pipe(
        catchError(error => {
            console.error('Error fetching AI Agent:', error);
            router.navigate([
                APP_SLUGS.MAIN,
                MAIN_SLUGS.SETTINGS,
                SETTINGS_SLUGS.departments,
                DEPARTMENTS_SLUGS.table,
            ]);
            return of(undefined);
        })
    );
};
